module.exports = __webpack_public_path__ + "img/1561728035.4e83e797.png";